import { render, staticRenderFns } from "./customers-table.vue?vue&type=template&id=d762f6fe&"
import script from "./customers-table.vue?vue&type=script&lang=ts&"
export * from "./customers-table.vue?vue&type=script&lang=ts&"
import style0 from "./customers-table.vue?vue&type=style&index=0&id=d762f6fe&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports